// AUTO GENERATED FILE - Changes WILL be lost.
// fi - used as 'fi' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Vetokuponki",
  "product.last60-row-single": "NBA:n viimeinen 60 yksittäisottelu",
  "product.sb-english-single": "Englannin jalkapallon yksinottelu",
  "product.sb-italian-single": "Italian Soccerbet-yksittäisottelu",
  "product.sb-greek-single": "Kreikan jalkapallon yksinottelu",
  "product.sb-english-league": "Englannin jalkapalloliiga",
  "product.sb-italian-league": "Italian jalkapalloliiga",
  "product.sb-greek-league": "Kreikan jalkapalloliiga",
  "last60.fixture": "{visitor} {'@'} {home}",
  "last60.fixtureResult": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture": "{home} VS. {away}",
  "sb.fixtureResult": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Aseta veto",
  "betslip.clear": "Tyhjennä",
  "betslip.clearResult": "Asia selvä",
  "betslip.noSelections": "Lisää valintoja aloittaaksesi vedonlyönnin",
  "betslip.notLoggedIn": "Kirjaudu sisään aloittaaksesi vedonlyönnin",
  "betslip.refresh": "virkistää",
  "betslip.totalStake": "Kokonaispanos",
  "betslip.noHistoryData": "Vedonlyöntitietoja ei ole saatavilla",
  "betslip.openBets": "Avaa vedot",
  "betslip.betHistory": "Vedonlyöntihistoria",
  "betslip.betHistoryWon": "Voitti",
  "betslip.betHistoryLost": "Kadonnut",
  "loading.loading": "Ladataan",
  "loading.account": "Ladataan tiliä",
  "loading.league": "Ladataan liigaa",
  "loading.gameweeks": "Peliviikkoja ladataan",
  "loading.markets": "Ladataan markkinoita",
  "loading.bethistory": "Ladataan vetohistoriaa",
  "login.loginRequired": "Sisäänkirjautuminen vaaditaan",
  "login.loginToBet": "Ole hyvä ja kirjaudu sisään aloittaaksesi vedonlyönnin",
  "navigation.back": "Takaisin",
  "navigation.close": "kiinni",
  "video.liveStreamAvailable": "Suora lähetys saatavilla",
  "video.logInToWatch": "Kirjaudu sisään katsoaksesi",
  "error.error": "Virhe",
  "error.404": "Sivua ei löydetty",
  "error.gameLaunchFailed": "Peliä ei voi käynnistää",
  "error.unknownErrorCode": "Tuntematon virhe: {code}",
  "error.minUnitStakeLimitExceeded": "Minimipanos on {limit}",
  "error.maxUnitStakeLimitExceeded": "Maksimipanos on {limit}",
  "error.minTotalStakeLimitExceeded": "Pienin kokonaispanos on {limit}",
  "error.maxTotalStakeLimitExceeded": "Suurin kokonaispanos on {limit}",
  "error.stakeInvalidMultiple": "Panoksen on oltava {multiple}:n kerrannainen",
  "error.notPlaced": "Ei sijoitettu",
  "error.wagerDisallowed": "Vedonlyönti kielletty",
  "error.errorEventIsOff": "Tapahtuma on alkanut",
  "multiplebet.Singles": "Sinkkuja",
  "multiplebet.Doubles": "Tuplaa",
  "multiplebet.Trebles": "Diskantit",
  "multiplebet.Accumulator": "Akku",
  "multiplebet.Perm 4-Folds": "Perm 4-taitto",
  "multiplebet.Perm 5-Folds": "Perm 5-taitto",
  "multiplebet.Perm 6-Folds": "Perm 6-taitto",
  "multiplebet.Perm 7-Folds": "Perm 7-taitto",
  "multiplebet.Perm 8-Folds": "Perm 8-taitto",
  "multiplebet.Perm 9-Folds": "Perm 9-taitto",
  "error.excess_bets": "Maksimi {limit} samanaikainen panos vetokupongilla; poista veto",
  "product.sb-turkish-league": "Turkin jalkapalloliiga",
  "error.minBetslipLimitExceeded": "Vetokupongin minimipanos on {limit}",
  "error.maxBetslipLimitExceeded": "Vetokupongin maksimipanos on {limit}",
  "error.exceededMaxPayout": "Suurin mahdollinen maksu on {limit}; pienennä panostasi",
  "betslip.potentialReturns": "Mahdolliset palautukset",
  "betslip.taxDisclaimer": "Kaikki nettovoittosi verotetaan vedonlyönnissä. Veron määrä lasketaan vedon mahdollisten voittojen mukaan.",
  "error.maintenanceEnabled": "Palvelin on parhaillaan huollossa",
  "error.internalError": "Sisäinen virhe",
  "error.invalidSession": "Istunto on virheellinen",
  "error.accountDisabled": "Tili on poistettu käytöstä",
  "error.invalidPlayerID": "Virheellinen pelaajatunnus",
  "error.insufficientBalance": "Riittämätön tasapaino",
  "error.configError": "Määritysvirhe",
  "error.betPlaceFailed": "Vedon asettaminen epäonnistui",
  "error.invalidProductID": "Virheellinen tuotetunnus",
  "error.playerReachedGamingLimits": "Pelaaja saavutti vastuullisen pelaamisen rajat",
  "error.gameCycleDoesNotExist": "Pelisykliä ei ole olemassa",
  "error.betAmountLimitExceeded": "Vahvistamattomien pelaajien mahdollinen voittoraja ylitetty",
  "betslip.netStake": "Nettopanos",
  "betslip.tax": "Verottaa",
  "error.badReturns": "Mahdollinen tuotto on pienempi kuin bruttopanos",
  "betslip.taxDisclaimerPoland": "Voitoista vähennetään 10 % yli 2 280 PLN:n summasta.",
  "sb-english.team.ARS": "ARS",
  "sb-english.team.AST": "AST",
  "sb-english.team.BHA": "BHA",
  "sb-english.team.BOU": "BOU",
  "sb-english.team.BUR": "BUR",
  "sb-english.team.CHE": "CHE",
  "sb-english.team.CRY": "CRY",
  "sb-english.team.EVE": "EVE",
  "sb-english.team.LEI": "LEI",
  "sb-english.team.LIV": "LIV",
  "sb-english.team.MNC": "MNC",
  "sb-english.team.MNU": "MNU",
  "sb-english.team.NEW": "NEW",
  "sb-english.team.SOU": "SOU",
  "sb-english.team.TOT": "TOT",
  "sb-english.team.WAT": "WAT",
  "sb-english.team.WHU": "WHU",
  "sb-english.team.WOL": "WOL",
  "sb-english.team.NOR": "NOR",
  "sb-english.team.SHU": "SHU",
  "sb-english.team.LEE": "LEE",
  "sb-english.team.FUL": "FUL",
  "sb-english.team.WBA": "WBA",
  "sb-greek.team.AEK": "AEK",
  "sb-greek.team.APS": "APS",
  "sb-greek.team.ARI": "ARI",
  "sb-greek.team.AST": "AST",
  "sb-greek.team.ATR": "ATR",
  "sb-greek.team.GIA": "GIA",
  "sb-greek.team.LEV": "LEV",
  "sb-greek.team.OFI": "OFI",
  "sb-greek.team.OLM": "OLM",
  "sb-greek.team.PTK": "PTK",
  "sb-greek.team.PNS": "PNS",
  "sb-greek.team.PAO": "PAO",
  "sb-greek.team.PLT": "PLT",
  "sb-greek.team.XAN": "XAN",
  "sb-italian.team.MIL": "MIL",
  "sb-italian.team.ATA": "ATA",
  "sb-italian.team.BOL": "BOL",
  "sb-italian.team.BRE": "BRE",
  "sb-italian.team.CAG": "CAG",
  "sb-italian.team.CHI": "CHI",
  "sb-italian.team.FIO": "FIO",
  "sb-italian.team.GEN": "GEN",
  "sb-italian.team.INT": "INT",
  "sb-italian.team.JUV": "JUV",
  "sb-italian.team.LAZ": "LAZ",
  "sb-italian.team.NAP": "NAP",
  "sb-italian.team.ROM": "ROM",
  "sb-italian.team.SAM": "SAM",
  "sb-italian.team.UDI": "UDI",
  "sb-italian.team.VER": "VER",
  "nomorebets": "Ei enää vetoja",
  "playtime": "Peliaika",
  "gameId": "Pelin tunnus",
  "noGames": "Pelejä ei ole saatavilla. Tarkista pian uudelleen.",
  "Home": "Koti",
  "Away": "Pois",
  "Visitor": "Vierailija",
  "rules": "säännöt",
  "soccerbet.gameWeek": "PELIVIIKKO",
  "soccerbet.noGameWeeks": "Peliviikkoja ei ole tarjolla. Tarkista pian uudelleen.",
  "soccerbet.league": "Liigan sijoitukset",
  "soccerbet.table.name": "Nimi",
  "soccerbet.table.won": "W",
  "soccerbet.table.drawn": "D",
  "soccerbet.table.lost": "L",
  "soccerbet.table.points": "PT",
  "market.abbr.Both Teams To Score": "BTTS",
  "market.Both Teams To Score": "Molemmat joukkueet tekevät maalin",
  "market.Over / Under": "Yli alle",
  "market.Double Chance": "Kaksinkertainen mahdollisuus",
  "market.Match Result": "Ottelun tulos",
  "market.Exact Goals": "Tarkat tavoitteet",
  "market.Correct Score": "Oikea pistemäärä",
  "market.Match Result Both Score": "Ottelun tulos ja molemmat joukkueet tekevät maalin",
  "market.Result Und/Over 1.5 Total Goals": "Ottelun tulos ja yli/alle 1,5 maalia yhteensä",
  "market.Result Und/Over 2.5 Total Goals": "Ottelun tulos ja yli/alle 2,5 maalia yhteensä",
  "market.Under Over 1.5 Total Goals": "Yli/alle 1,5 maalia yhteensä",
  "market.Under Over 2.5 Total Goals": "Yli/alle 2,5 maalia yhteensä",
  "market.Under Over 3.5 Total Goals": "Yli/alle 3,5 maalia yhteensä",
  "market.Under Over 4.5 Total Goals": "Yli/alle 4,5 maalia yhteensä",
  "market.Total Goals 1 To 2": "Tavoitteet yhteensä 1-2",
  "market.Total Goals 1 To 3": "Tavoitteet yhteensä 1-3",
  "market.Total Goals 1 To 4": "Tavoitteet yhteensä 1-4",
  "market.Total Goals 2 To 3": "Tavoitteet yhteensä 2-3",
  "market.Total Goals 2 To 4": "Tavoitteet yhteensä 2-4",
  "market.Under Over 1.5 Home Goals": "Yli/alle 1,5 kotijoukkueen maalia",
  "market.Under Over 1.5 Away Goals": "Yli/alle 1,5 vierasjoukkueen maalia",
  "market.Home Team Exact Goals": "Kotijoukkueen tarkat maalit",
  "market.Away Team Exact Goals": "Vierasjoukkueen tarkat maalit",
  "selection.Yes": "Joo",
  "selection.No": "Ei",
  "selection.1+G": "1+G",
  "selection.1+Ng": "1+Ng",
  "selection.X+G": "X+G",
  "selection.X+Ng": "X+Ng",
  "selection.2+G": "2+G",
  "selection.2+Ng": "2+Ng",
  "selection.1+Yes": "1+Kyllä",
  "selection.1+No": "1+Ei",
  "selection.X+Yes": "X+Kyllä",
  "selection.X+No": "X+Ei",
  "selection.2+Yes": "2+Kyllä",
  "selection.2+No": "2+Ei",
  "selection.TID_ANY_GOAL_SCORED_YES": "G",
  "selection.TID_ANY_GOAL_SCORED_NO": "Ng",
  "selection.U": "U",
  "selection.O": "O",
  "selection.1+O": "1+O",
  "selection.X+O": "X+O",
  "selection.2+O": "2+O",
  "selection.1+U": "1+U",
  "selection.X+U": "X+U",
  "selection.2+U": "2+U",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Over": "YLI",
  "selection.Under": "ALLA",
  "sb-english.team.abbr.ARS": "ARS",
  "sb-english.team.abbr.AST": "AST",
  "sb-english.team.abbr.BHA": "BHA",
  "sb-english.team.abbr.BOU": "BOU",
  "sb-english.team.abbr.BUR": "BUR",
  "sb-english.team.abbr.CHE": "CHE",
  "sb-english.team.abbr.CRY": "CRY",
  "sb-english.team.abbr.EVE": "EVE",
  "sb-english.team.abbr.LEI": "LEI",
  "sb-english.team.abbr.LIV": "LIV",
  "sb-english.team.abbr.MNC": "MNC",
  "sb-english.team.abbr.MNU": "MNU",
  "sb-english.team.abbr.NEW": "NEW",
  "sb-english.team.abbr.SOU": "SOU",
  "sb-english.team.abbr.TOT": "TOT",
  "sb-english.team.abbr.WAT": "WAT",
  "sb-english.team.abbr.WHU": "WHU",
  "sb-english.team.abbr.WOL": "WOL",
  "sb-english.team.abbr.NOR": "NOR",
  "sb-english.team.abbr.SHU": "SHU",
  "sb-english.team.abbr.LEE": "LEE",
  "sb-english.team.abbr.FUL": "FUL",
  "sb-english.team.abbr.WBA": "WBA",
  "sb-italian.team.abbr.MIL": "MIL",
  "sb-italian.team.abbr.ATA": "ATA",
  "sb-italian.team.abbr.BOL": "BOL",
  "sb-italian.team.abbr.BRE": "BRE",
  "sb-italian.team.abbr.CAG": "CAG",
  "sb-italian.team.abbr.CHI": "CHI",
  "sb-italian.team.abbr.FIO": "FIO",
  "sb-italian.team.abbr.GEN": "GEN",
  "sb-italian.team.abbr.INT": "INT",
  "sb-italian.team.abbr.JUV": "JUV",
  "sb-italian.team.abbr.LAZ": "LAZ",
  "sb-italian.team.abbr.NAP": "NAP",
  "sb-italian.team.abbr.ROM": "ROM",
  "sb-italian.team.abbr.SAM": "SAM",
  "sb-italian.team.abbr.UDI": "UDI",
  "sb-italian.team.abbr.VER": "VER",
  "sb-greek.team.abbr.AEK": "AEK",
  "sb-greek.team.abbr.APS": "APS",
  "sb-greek.team.abbr.ARI": "ARI",
  "sb-greek.team.abbr.AST": "AST",
  "sb-greek.team.abbr.ATR": "ATR",
  "sb-greek.team.abbr.GIA": "GIA",
  "sb-greek.team.abbr.LEV": "LEV",
  "sb-greek.team.abbr.OFI": "OFI",
  "sb-greek.team.abbr.OLM": "OLM",
  "sb-greek.team.abbr.PTK": "PTK",
  "sb-greek.team.abbr.PNS": "PNS",
  "sb-greek.team.abbr.PAO": "PAO",
  "sb-greek.team.abbr.PLT": "PLT",
  "sb-greek.team.abbr.XAN": "XAN",
  "sb-turkish.team.AKB": "AKHİSARSPOR",
  "sb-turkish.team.BES": "BEŞIKTAŞ",
  "sb-turkish.team.FEN": "FENERBAHÇE",
  "sb-turkish.team.GAL": "GALATASARAY",
  "sb-turkish.team.TRA": "TRABZONSPOR",
  "sb-turkish.team.ANT": "ANTALYASPOR",
  "sb-turkish.team.GEN": "GENÇLERBİRLİĞİ",
  "sb-turkish.team.KAS": "KASIMPAŞA",
  "sb-turkish.team.BUR": "BURSASPOR",
  "sb-turkish.team.KAY": "KAYSERİSPOR",
  "sb-turkish.team.SIV": "SİVASSPOR",
  "sb-turkish.team.IBA": "İSTANBUL BAŞAKŞEHIR",
  "sb-turkish.team.HAT": "HATAYSPOR",
  "sb-turkish.team.ADS": "AD. DEMIRSPOR",
  "sb-turkish.team.ALT": "ALTAY",
  "sb-turkish.team.GAZ": "GAZIANTEP",
  "sb-turkish.team.GOZ": "GÖZTEPE",
  "sb-turkish.team.KON": "KONYASPOR",
  "sb-turkish.team.CRS": "Ç. RIZESPOR",
  "sb-turkish.team.ALS": "ALANYASPOR",
  "sb-turkish.team.abbr.AKB": "AKB",
  "sb-turkish.team.abbr.BES": "BES",
  "sb-turkish.team.abbr.FEN": "FEN",
  "sb-turkish.team.abbr.GAL": "GAL",
  "sb-turkish.team.abbr.TRA": "TRA",
  "sb-turkish.team.abbr.ANT": "ANT",
  "sb-turkish.team.abbr.GEN": "GEN",
  "sb-turkish.team.abbr.KAS": "KAS",
  "sb-turkish.team.abbr.BUR": "BUR",
  "sb-turkish.team.abbr.KAY": "KAY",
  "sb-turkish.team.abbr.SIV": "SIV",
  "sb-turkish.team.abbr.IBA": "IBA",
  "sb-turkish.team.abbr.HAT": "HAT",
  "sb-turkish.team.abbr.ADS": "ADS",
  "sb-turkish.team.abbr.ALT": "ALT",
  "sb-turkish.team.abbr.GAZ": "GAZ",
  "sb-turkish.team.abbr.GOZ": "GOZ",
  "sb-turkish.team.abbr.KON": "KON",
  "sb-turkish.team.abbr.CRS": "CRS",
  "sb-turkish.team.abbr.ALS": "ALS",
  "sb-english.team.BRE": "Brentford",
  "sb-english.team.abbr.BRE": "BRE",
  "sb-english.team.NOT": "Nottingham Forest",
  "sb-english.team.abbr.NOT": "NOT",
  "market.Overall Winner": "Kokonaisvoittaja",
  "market.Last60 Winner": "Viimeisen 60 voittaja",
  "market.Both Teams Over 2.5 Last60": "Molemmat joukkueet yli 2,5, viimeiset 60",
  "market.Both Teams Over 3.5 Last60": "Molemmat joukkueet yli 3,5, viimeiset 60",
  "market.First Team To Score In Last60": "Ensimmäinen maalintekijä viimeisen 60:n joukossa",
  "market.Last60 Winner And Winning Margin": "Viimeiset 60 voittaja ja voittomarginaali",
  "market.First To Score 4 Points Last60": "Ensimmäinen, joka tekee 4 pistettä, viimeiset 60",
  "market.Home Under/Over 4.5 Last60": "{home} Yli/alle 4,5 Viimeiset 60",
  "market.Visitor Under/Over 4.5 Last60": "{visitor} Yli/alle 4,5 Viimeiset 60",
  "market.Home Under/Over 5.5 Last60": "{home} Yli/alle 5,5 Viimeiset 60",
  "market.Visitor Under/Over 5.5 Last60": "{visitor} Yli/alle 5,5 Viimeiset 60",
  "market.Last60 Winner And O/U 11.5": "Viimeisen 60 voittaja ja O/U 11.5",
  "market.Last60 Points Difference": "Viimeiset 60 voittomarginaalia",
  "market.Total 3-Pointers Last60": "Kolmen pisteen yhteensä viimeiset 60",
  "selection.Home & 1-3": "{home} & 1-3",
  "selection.Home & 4-6": "{home} & 4-6",
  "selection.Home & 7-9": "{home} & 7-9",
  "selection.Home & 10-12": "{home} & 10-12",
  "selection.Home & 13+": "{home} & 13+",
  "selection.Visitor & 1-3": "{visitor} & 1-3",
  "selection.Visitor & 4-6": "{visitor} & 4-6",
  "selection.Visitor & 7-9": "{visitor} & 7-9",
  "selection.Visitor & 10-12": "{visitor} & 10-12",
  "selection.Visitor & 13+": "{visitor} & 13+",
  "selection.Home & Over": "{home} ja yli",
  "selection.Home & Under": "{home} & Under",
  "selection.Visitor & Over": "{visitor} ja yli",
  "selection.Visitor & Under": "{visitor} ja alle",
  "last60.team.ATL": "Atlanta Hawks",
  "last60.team.BKN": "Brooklyn Nets",
  "last60.team.BOS": "Boston Celtics",
  "last60.team.CHA": "Charlotte Hornets",
  "last60.team.CHI": "Chicago Bulls",
  "last60.team.CLE": "Cleveland Cavaliers",
  "last60.team.DAL": "Dallas Mavericks",
  "last60.team.DEN": "Denver Nuggets",
  "last60.team.DET": "Detroit Pistons",
  "last60.team.GSW": "Golden State Warriors",
  "last60.team.HOU": "Houston Rockets",
  "last60.team.IND": "Indiana Pacers",
  "last60.team.LAC": "LA Clippers",
  "last60.team.LAL": "Los Angeles Lakers",
  "last60.team.MEM": "Memphis Grizzlies",
  "last60.team.MIA": "Miami Heat",
  "last60.team.MIL": "Milwaukee Bucks",
  "last60.team.MIN": "Minnesota Timberwolves",
  "last60.team.NOP": "New Orleans Pelicans",
  "last60.team.NYK": "New York Knicks",
  "last60.team.OKC": "Oklahoma City Thunder",
  "last60.team.ORL": "Orlando Magic",
  "last60.team.PHI": "Philadelphia 76ers",
  "last60.team.PHX": "Phoenix Suns",
  "last60.team.POR": "Portland Trail Blazers",
  "last60.team.SAC": "Sacramento Kings",
  "last60.team.SAS": "San Antonio Spurs",
  "last60.team.TOR": "Toronto Raptors",
  "last60.team.UTA": "Utah Jazz",
  "last60.team.WAS": "Washington Wizards",
  "last60.team.abbr.ATL": "ATL",
  "last60.team.abbr.BKN": "BKN",
  "last60.team.abbr.BOS": "BOS",
  "last60.team.abbr.CHA": "CHA",
  "last60.team.abbr.CHI": "CHI",
  "last60.team.abbr.CLE": "CLE",
  "last60.team.abbr.DAL": "DAL",
  "last60.team.abbr.DEN": "DEN",
  "last60.team.abbr.DET": "DET",
  "last60.team.abbr.GSW": "GSW",
  "last60.team.abbr.HOU": "HOU",
  "last60.team.abbr.IND": "IND",
  "last60.team.abbr.LAC": "LAC",
  "last60.team.abbr.LAL": "LAL",
  "last60.team.abbr.MEM": "MEM",
  "last60.team.abbr.MIA": "MIA",
  "last60.team.abbr.MIL": "MIL",
  "last60.team.abbr.MIN": "MIN",
  "last60.team.abbr.NOP": "NOP",
  "last60.team.abbr.NYK": "NYK",
  "last60.team.abbr.OKC": "OKC",
  "last60.team.abbr.ORL": "ORL",
  "last60.team.abbr.PHI": "PHI",
  "last60.team.abbr.PHX": "PHX",
  "last60.team.abbr.POR": "POR",
  "last60.team.abbr.SAC": "SAC",
  "last60.team.abbr.SAS": "SAS",
  "last60.team.abbr.TOR": "TOR",
  "last60.team.abbr.UTA": "UTA",
  "last60.team.abbr.WAS": "WAS",
  "selection.Home": "{home}",
  "selection.Visitor": "{visitor}",
  "market.Total 3-Pointers Last60 1-6": "Kolmen pisteen yhteensä viimeiset 60",
  "market.Last60 Winning Margin 1": "Viimeiset 60 voittomarginaalia",
  "market.Last60 Winning Margin 2": "Viimeiset 60 voittomarginaalia",
  "market.Last60 Winning Margin 3": "Viimeiset 60 voittomarginaalia",
  "market.Last60 Winner & Winning Margin 1": "Viimeisen 60 voittaja ja voittomarginaali",
  "market.Last60 Winner & Winning Margin 2": "Viimeisen 60 voittaja ja voittomarginaali",
  "market.Last60 Winner & Winning Margin 3": "Viimeisen 60 voittaja ja voittomarginaali",
  "market.Total 3-Pointers Last60 1-3+": "Kolmen pisteen yhteensä viimeiset 60",
  "selection.Home & 1": "{home} & 1",
  "selection.Home & 2": "{home} & 2",
  "selection.Home & 3": "{home} & 3",
  "selection.Home & 4": "{home} & 4",
  "selection.Home & 5": "{home} & 5",
  "selection.Home & 6": "{home} & 6",
  "selection.Home & 7": "{home} & 7",
  "selection.Home & 8": "{home} & 8",
  "selection.Home & 9": "{home} & 9",
  "selection.Home & 10": "{home} & 10",
  "selection.Home & 11": "{home} & 11",
  "selection.Home & 12": "{home} & 12",
  "selection.Home & 13": "{home} & 13",
  "selection.Home & 14": "{home} & 14",
  "selection.Home & 15": "{home} & 15",
  "selection.Home & 16": "{home} & 16",
  "selection.Home & 17+": "{home} & 17+",
  "selection.Visitor & 1": "{visitor} & 1",
  "selection.Visitor & 2": "{visitor} & 2",
  "selection.Visitor & 3": "{visitor} & 3",
  "selection.Visitor & 4": "{visitor} & 4",
  "selection.Visitor & 5": "{visitor} & 5",
  "selection.Visitor & 6": "{visitor} & 6",
  "selection.Visitor & 7": "{visitor} & 7",
  "selection.Visitor & 8": "{visitor} & 8",
  "selection.Visitor & 9": "{visitor} & 9",
  "selection.Visitor & 10": "{visitor} & 10",
  "selection.Visitor & 11": "{visitor} & 11",
  "selection.Visitor & 12": "{visitor} & 12",
  "selection.Visitor & 13": "{visitor} & 13",
  "selection.Visitor & 14": "{visitor} & 14",
  "selection.Visitor & 15": "{visitor} & 15",
  "selection.Visitor & 16": "{visitor} & 16",
  "selection.Visitor & 17+": "{visitor} & 17+",
  "selection.Home & 1-2": "{home} & 1-2",
  "selection.Home & 3-4": "{home} & 3-4",
  "selection.Home & 5-6": "{home} & 5-6",
  "selection.Home & 7-8": "{home} & 7-8",
  "selection.Home & 9-10": "{home} & 9-10",
  "selection.Home & 11-12": "{home} & 11-12",
  "selection.Home & 13-14": "{home} & 13-14",
  "selection.Home & 15-16": "{home} & 15-16",
  "selection.Visitor & 1-2": "{visitor} & 1-2",
  "selection.Visitor & 3-4": "{visitor} & 3-4",
  "selection.Visitor & 5-6": "{visitor} & 5-6",
  "selection.Visitor & 7-8": "{visitor} & 7-8",
  "selection.Visitor & 9-10": "{visitor} & 9-10",
  "selection.Visitor & 11-12": "{visitor} & 11-12",
  "selection.Visitor & 13-14": "{visitor} & 13-14",
  "selection.Visitor & 15-16": "{visitor} & 15-16"
}
